{
  "mySystems": {
    "title": "Mes systèmes",
    "description": "Systèmes logiciels dont vous êtes responsable et que vous gérez.",
    "empty": "Vous ne gérez aucun système logiciel dans votre organisation."
  },
  "systemLandscape": {
    "title": "Paysage système",
    "view": {
      "list": "Liste",
      "2d": "2D",
      "3d": "3D"
    },
    "kpi": {
      "systems": "Systèmes",
      "systemsDesc": "Systèmes actifs au total",
      "connections": "Connexions",
      "connectionsDesc": "Interactions système à système",
      "avgConnections": "Connexions moy.",
      "avgConnectionsDesc": "Par système",
      "isolated": "Systèmes isolés",
      "isolatedDesc": "Systèmes sans connexions",
      "mediaBreaks": "Ruptures média",
      "mediaBreaksDesc": "Ruptures de transition entre systèmes"
    },
    "list": {
      "connections": "Connexions",
      "mediaBreaks": "Ruptures média"
    },
    "tooltip": {
      "upstream": "Reçoit de",
      "downstream": "Envoie vers",
      "interactionCount": "{{count}} interactions"
    },
    "navInfo": "Clic gauche : rotation · Molette : zoom · Clic droit : panoramique"
  },
  "shadowSystems": {
    "title": "Systèmes fantômes",
    "description": "Logiciels utilisés par les employés dans des enregistrements de processus terminés mais refusés pour le catalogue officiel — votre informatique fantôme, rendue visible.",
    "search": "Rechercher des systèmes fantômes...",
    "empty": "Aucun système fantôme — tous les logiciels référencés dans les enregistrements terminés sont approuvés.",
    "stats": {
      "shadowSystems": "Systèmes fantômes",
      "recordingsAffected": "Enregistrements terminés concernés"
    },
    "columns": {
      "system": "Système",
      "category": "Catégorie",
      "url": "Lien",
      "openLink": "Ouvrir le lien externe",
      "occurrences": "Occurrences",
      "suggestedBy": "Suggéré par",
      "submittedAt": "Suggéré le",
      "reviewedBy": "Refusé par",
      "reviewedAt": "Refusé le",
      "rejectionReason": "Motif du refus",
      "source": "Source"
    },
    "actions": {
      "resolve": "Résoudre",
      "resolved": "Système fantôme résolu"
    },
    "resolveDialog": {
      "title": "Résoudre le système fantôme",
      "description": "Description",
      "useExisting": "Fusionner avec un existant",
      "createNew": "Créer un nouveau système",
      "targetSystem": "Système cible",
      "selectSystem": "Sélectionner un système",
      "name": "Nom",
      "systemOwner": "Propriétaire du système",
      "selectOwner": "Sélectionner un responsable",
      "category": "Catégorie",
      "url": "Lien"
    }
  }
}
